import { useEffect } from 'react';
import i18n from './i18n/index.ts';

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const app = i18n.t('app.name');
    document.title = title === app ? app : `${title} · ${app}`;
  }, [title]);
}
